<!-- ===================== DISCUSSIONS: MOBILE + DESKTOP ===================== -->

<div>

  <div class="event-survey-experience card border-1 rounded-5 p-3 p-md-4 mb-4 bg-light shadow-sm overflow-hidden">
    <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 gap-md-4">
      <div class="d-flex align-items-start gap-3 flex-grow-1">
        <div class="d-inline-flex align-items-center justify-content-center rounded bg-light text-primary fs-4 py-2 px-3 flex-shrink-0">
          <i class="bi bi-chat-left-text"></i>
        </div>
        <div class="flex-grow-1">
          <h6 class="mb-2 fw-bold text-dark">Discussions worth joining</h6>
          <p class="mb-0 text-muted text-xs">
            Start a topic, react to what others are saying, and keep the conversation moving in one place.
          </p>
        </div>
      </div>

      <div class="d-flex flex-column align-items-start align-items-lg-end gap-3">
        <div class="d-none d-md-flex flex-nowrap gap-2 justify-content-lg-end w-100 w-lg-auto">
          <div class="card board-task-card border-0 rounded-4 bg-white px-3 py-2 flex-fill shadow-sm">
            <span class="d-block text-uppercase fw-bold text-secondary small">Topics</span>
            <strong class="d-block fw-bold text-dark fs-5">{{ disscussion_topics.length }}</strong>
          </div>
        </div>

        <button class="btn btn-primary btn-sm rounded px-3 py-1 shadow-sm text-xxs align-self-lg-end text-nowrap"
                @click="open_discussion_form">
          Start discussion
        </button>
      </div>
    </div>
  </div>

  <!-- ===================== INLINE FORM (REPLACING MODAL) ===================== -->
  <div v-if="showDiscussionForm" class="card border-1 rounded-5 p-3 p-md-4 shadow-sm mb-3 mt-2 position-relative bg-white">

    <form @submit.prevent="create_discussion_topic">
      <button class="btn btn-sm text-muted position-absolute top-0 end-0 m-2"
                            @click="close_discussion_form" title="Close">
                            <i class="bi bi-x-lg fs-5 fw-bold text-dark"></i>
                        </button>

      <div class="mb-4 col-xl-8 px-0">
        <div class="text-uppercase fw-bold text-primary small mb-1">Start a discussion</div>
        <h5 class="fw-bold text-dark mb-1">Open a conversation people will want to join</h5>
        <p class="text-muted text-sm mb-0">Keep the title clear, add enough context, and make it easy for others to respond.</p>
      </div>

      <div class="mb-3">
        <label class="form-label text-xxs fw-500">
          Topic name <span class="text-danger">*</span>
        </label>

        <input type="text"
               class="form-control rounded text-xxs"
               placeholder="Enter topic name"
               v-model="topic_name" />

        <p v-if="errors.topic_name" class="text-danger text-xxs mt-1">
          {{ errors.topic_name }}
        </p>
      </div>

      <div class="mb-3">
        <label class="form-label text-xxs fw-500">
          Discussion Description <span class="text-danger">*</span>
        </label>

        <QuillEditor theme="snow"
                     v-model="description"
                     ref="quillDiscussionsEditorRef"
                     class="quill-editor"
                     placeholder="Enter your description here..."
                     toolbar="half" />

        <p v-if="errors.description" class="text-danger text-xxs mt-1">
          {{ errors.description }}
        </p>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <button type="submit"
                class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm px-3">
          Save
        </button>
      </div>

    </form>
  </div>

  <!-- ===================== LIST SECTION ===================== -->
<div v-if="!showDiscussionForm && !showEditTopicForm">

    <!-- EMPTY STATE -->
    <div v-if="disscussion_topics.length === 0" class="text-center">
      <div class="p-1 py-3">
        <section class="card border-1 rounded-5 p-3 mb-3 bg-white shadow-sm">
          <div class="text-uppercase fw-bold text-primary small mb-1 text-start">Discussion space</div>
          <h6 class="mb-0 fw-bold text-dark text-start">No discussions yet</h6>

          <div class="py-5 d-flex flex-column align-items-center justify-content-center text-center">
            <i class="bi bi-chat-left-text fs-1 mb-3 text-primary"></i>
            <p class="mb-0 text-muted text-xs">
              Start the first conversation for this space.
            </p>
          </div>

        </section>
      </div>
    </div>

    <!-- LIST OF DISCUSSIONS -->
    <div v-else>
      <section class="card border-1 rounded-5 p-1 p-md-3 mb-3 bg-light shadow-sm">
        <div class="d-flex justify-content-between align-items-center gap-3 mb-2 flex-wrap">
          <div>
            <div class="text-uppercase fw-bold text-primary small mb-1 ms-2 mt-1">Open conversations</div>
          </div>
        </div>

        <div v-for="topic in disscussion_topics" :key="topic.id">
        <div
           class="card card-hover mb-2 mb-md-3 p-2 p-md-4 d-flex flex-column rounded-4 border-0 full-width-mobile shadow-sm bg-white position-relative overflow-hidden"
           @click="display_comment_modal(topic)">
          <div class="d-none d-lg-block position-absolute top-0 start-0 w-100 h-100 board-task-card rounded-4 pe-none bg-transparent shadow-none"></div>

        <div class="row">
          <div class="col">

            <div class="d-flex flex-start">
              <img
                  :src="topic.created_by?.profile_type === 'personal'
                    ?(get_personal_profile_picture(topic?.created_by?.user?.profile?.profile_files))
                    : (topic.created_by?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
                    loading="lazy"
                    class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                />

              <div class="flex-grow-1 flex-shrink-1">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="fw-500 mt-1 lh-2 text-xxs ms-2">
                      <span v-if="topic.created_by?.profile_type === 'personal'">{{ topic.created_by?.user?.first_name }} {{ topic.created_by?.user?.last_name }}</span>
                      <span v-if="topic.created_by?.profile_type === 'business'">{{topic?.created_by?.company?.company_name}}</span>
                    <br>
                    <span class="text-xxs ">
                      {{ topic.date_created }} <i class="bx bxs-stopwatch"></i>
                    </span>
                  </p>

                  <div class="dropstart" @click.stop
                    v-if="String(topic.created_by?.user?.id) === String(user_details.user_id) || user_details.user_role === 'admin'">
                    <a class="fw-bold text-dark"
                       data-bs-toggle="dropdown">
                      <i class="bi bi-three-dots-vertical"></i>
                    </a>

                    <ul class="dropdown-menu custom-dropdown lh-1 text-xxs">
                      <li v-if="String(topic.created_by?.user?.id) === String(user_details.user_id)">
                        <a class="dropdown-item" @click.prevent="edit_topic(topic)">
                          <i class="bx bxs-edit fs-6"></i> Edit
                        </a>
                      </li>

                      <li>
                        <a class="dropdown-item text-danger text-xxs"
                           @click.prevent="delete_topic(topic.id)">
                          <i class="bx bxs-trash-alt fs-6"></i> Delete
                        </a>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>

            <div class="text-uppercase fw-bold text-primary small mb-2 mt-2">Discussion topic</div>
            <h6 class="fw-bold text-dark mb-2">{{ topic.name }}</h6>
          <div class="quill-wrapper">
            <div
              v-html="displayedDescription(topic)"
              :class="['ql-editor quill-content','text-xxs','text-muted','lh-lg', { expanded: isExpanded(topic.id) }]"
            ></div>

            <!-- Read More / Read Less Toggle -->
            <span v-if="topic.description.length > maxLength" class="text-secondary cursor-pointer text-xxs ms-1"
              @click.stop="toggleDescription(topic.id)">
              {{ isExpanded(topic.id) ? ' Read Less' : 'Read More' }}
              <i v-if="!isExpanded(topic.id)" class="bx bx-down-arrow-circle"></i>
              <i v-else class="bx bx-up-arrow-circle"></i>
            </span>
            </div>

            <div class="d-flex justify-content-between align-items-center gap-2 mt-3 flex-wrap">
              <button
                type="button"
                class="btn btn-light border rounded-3 shadow-sm text-xxs d-inline-flex align-items-center gap-2 px-3 py-2"
                @click.stop="display_comment_modal(topic)"
              >
                <i class="bi bi-chat-dots text-primary"></i>
                <span>{{ comment_modal_visible && report_data && report_data.id === topic.id ? 'Hide comments' : 'Open discussion' }}</span>
              </button>
              <span class="d-inline-flex align-items-center gap-1 text-xxs text-muted fw-semibold">
                {{ topic.comments_count }} <i class='bx bxs-comment'></i>
              </span>
            </div>

          </div>
        </div>

          <DisscussionComment
            v-if="comment_modal_visible && report_data && report_data.id === topic.id"
            :discussion="report_data"
            :active_profile="active_profile"
            @hide_comment="hide_comment"
          />
        </div>
      </div>
      </section>
    </div>

  </div>
  

<!-- ===================== INLINE EDIT TOPIC PANEL (NO MODAL) ===================== -->
<div v-if="showEditTopicForm" class="card border-1 rounded-5 p-3 p-md-4 shadow-sm mb-3 mt-2 position-relative bg-white">

  <!-- CLOSE BUTTON -->
  <button class="btn btn-sm text-muted position-absolute top-0 end-0 m-2"
                            @click="cancel_edit_topic" title="Close">
                            <i class="bi bi-x-lg fs-5 fw-bold text-dark"></i>
                        </button>

  <div class="mb-4 col-xl-8 px-0">
    <div class="text-uppercase fw-bold text-primary small mb-1">Edit discussion</div>
    <h5 class="fw-bold text-dark mb-1">Refine your topic</h5>
    <p class="text-muted text-sm mb-0">Tighten the title or update the description before more people join the conversation.</p>
  </div>

  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Topic name</label>
    <input type="text"
           class="form-control rounded text-xxs"
           v-model="editTopicData.title" />
  </div>

  <div class="mb-3">
    <label class="form-label text-xxs fw-500">Discussion Description</label>

    <QuillEditor theme="snow"
                 v-model="editTopicData.description"
                 ref="quillDiscussionsUpdateEditorRef"
                 class="quill-editor"
                 toolbar="half" />
  </div>

  <div class="d-flex justify-content-end gap-2">
   

    <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow-sm px-3"
            @click="save_topic_edits">
      Save
    </button>
  </div>

</div>

</div>
